import { useMemo } from 'react';
import { FileText, FolderOpen, Layers, TriangleAlert } from 'lucide-react';

import { cn } from '@/lib/utils';

import { useCollections } from '../../hooks/useCollections';

function format(n: number) {
  return n.toLocaleString('pt-BR');
}

/** Faixa compacta de métricas agregadas — visão global no topo da tela. */
export function CollectionsStats() {
  const { data: collections } = useCollections();

  const totals = useMemo(() => {
    const list = collections ?? [];
    return {
      collections: list.length,
      documents: list.reduce((s, c) => s + c.total_documents, 0),
      chunks: list.reduce((s, c) => s + c.total_chunks, 0),
      failed: list.reduce((s, c) => s + c.failed, 0),
    };
  }, [collections]);

  if (!collections) return null;

  const items = [
    { icon: FolderOpen, label: 'Coleções', value: format(totals.collections), alert: false },
    { icon: FileText, label: 'Documentos', value: format(totals.documents), alert: false },
    { icon: Layers, label: 'Chunks', value: format(totals.chunks), alert: false },
    {
      icon: TriangleAlert,
      label: 'Falhas',
      value: format(totals.failed),
      alert: totals.failed > 0,
    },
  ];

  return (
    <div className="hidden items-center gap-1.5 sm:flex">
      {items.map((it) => (
        <div
          key={it.label}
          className={cn(
            'flex items-center gap-1.5 rounded-md border px-2.5 py-1',
            it.alert && 'border-destructive/30 bg-destructive/5',
          )}
        >
          <it.icon
            className={cn('size-3.5', it.alert ? 'text-destructive' : 'text-muted-foreground')}
          />
          <span
            className={cn('text-xs font-semibold tabular-nums', it.alert && 'text-destructive')}
          >
            {it.value}
          </span>
          <span className="text-muted-foreground text-xs">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
